// Module
var code = "<div data-bind=\"html: iconHtml\"></div>\r\n";
// Exports
module.exports = code;